export default __webpack_public_path__ + "static/media/plus.f21d8cca.svg";